// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlockLayout_wrapper__1PfmI"};